(function($) {
  'use strict';

  var initAlumniSlider = function() {
    var showArrowsMinWidth = 1060;

    //toggle dots vs. arrows
    var toggleDots = function(slider) {
      //show active slide text
      slider.find('.slick-current.slick-center .alumni-slider__text').fadeIn('fast');
      //show/hide arrows vs. dots
      if (slider.width() < showArrowsMinWidth) {
        slider.find('.slick-arrow').hide();
        slider.find('.slick-dots').show();
      } else {
        slider.find('.slick-arrow').show();
        slider.find('.slick-dots').hide();
      }
    };

    //get all alumni sliders
    var alumniSliders = $('.alumni-slider__items');
    //init each testimonial
    alumniSliders.each(function() {
      //init only if it has more than one slide
      var slidesNum = $(this).find('.alumni-slider__item').length;

      if (slidesNum > 1) {
        var alumniSlider = $(this).slick({
          dots:           true,
          slidesToShow:   5,
          slidesToScroll: 1,
          centerMode:     true,
          variableWidth:  true,
          focusOnSelect:  true,
          dotsClass:      'slick-dots slick-dots--colored',
          prevArrow:
            '<button class="btn btn--chevron btn--chevron-left slick-prev"><svg focusable="false" xmlns="http://www.w3.org/2000/svg" width="10" height="16"><path fill="#7D5177" fill-rule="evenodd" d="M1.893 0L0 1.868 6.214 8 0 14.13 1.893 16 10 8z" /></svg>Next</button>',
          nextArrow:
            '<button class="btn btn--chevron btn--chevron slick-next"><svg focusable="false" xmlns="http://www.w3.org/2000/svg" width="10" height="16"><path fill="#7D5177" fill-rule="evenodd" d="M1.893 0L0 1.868 6.214 8 0 14.13 1.893 16 10 8z" /></svg>Previous</button>'
        });

        //switch between dots vs. arrows
        toggleDots(alumniSlider);

        //record current slide ID for use as previous slide before slide change
        alumniSlider.on('beforeChange', function(event, slick, currentSlide) {
          $(slick.$slides[currentSlide])
            .find('.alumni-slider__text')
            .hide();
        });

        //reset embeded media after slide change
        alumniSlider.on('afterChange', function(event, slick, currentSlide) {
          $(slick.$slides[currentSlide])
            .find('.alumni-slider__text')
            .fadeIn('fast');
        });
      }
    });

    var resizeTimer;
    var sliders = $('.alumni-slider .slick-slider');

    //show hide carousel arrows/dots on window resize
    $(window).on('resize', function() {
      //throttle resize event
      //https://css-tricks.com/snippets/jquery/done-resizing-event/
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        sliders.each(function() {
          toggleDots($(this));
        });
      }, 100);
    });
  };

  //init
  initAlumniSlider();
}(jQuery));
